export enum AssetTagRouteName {
    Index = 'asset-tags.index',
}

export default {
    path: '/asset-tags',
    component: () => import('@/views/asset-tag/Index.vue'),
    name: AssetTagRouteName.Index,
    meta: {
        label: 'Asset Tags',
        auth: true,
        permission: 'asset:tags:generate',
    },
}
